import {BulkUploadShellConfig} from './bulk-upload-flow';
import {
    VEHICLE_MONITORING_BULK_UPLOAD_SUPPORTED_FIELDS,
    VEHICLE_MONITORING_BULK_UPLOAD_SUPPORTED_TIP,
} from '../vehicle-monitoring/vehicle-monitoring.constants';

/**
 * Shared BulkUploadShell presentation configs.
 * Vehicle Monitoring is the platform reference; other modules differ by copy/options only.
 */

/** Platform-standard modal shell (Vehicle Monitoring reference). */
export const VEHICLE_MONITORING_BULK_UPLOAD_SHELL: BulkUploadShellConfig = {
    title: 'Bulk Upload',
    intro: 'Upload a CSV or Excel file to add multiple vehicles to monitoring.',
    showDownloadTemplate: false,
    supportedFields: VEHICLE_MONITORING_BULK_UPLOAD_SUPPORTED_FIELDS,
    supportedTip: VEHICLE_MONITORING_BULK_UPLOAD_SUPPORTED_TIP,
};

export const VEHICLE_DATABASE_BULK_UPLOAD_SHELL: BulkUploadShellConfig = {
    title: 'Bulk Upload',
    intro: 'Upload a CSV or Excel file to add multiple vehicles.',
    showDownloadTemplate: false,
    showGuidelines: false,
};

export const HOTLIST_BULK_UPLOAD_SHELL: BulkUploadShellConfig = {
    title: 'Bulk Upload',
    intro: 'Upload a CSV or Excel file to add multiple hotlisted vehicles.',
    showDownloadTemplate: false,
};

export const BLOCKLIST_BULK_UPLOAD_SHELL: BulkUploadShellConfig = {
    title: 'Bulk Upload',
    intro: 'Upload a CSV or Excel file to add multiple blacklisted vehicles.',
    showDownloadTemplate: false,
};
